import RAFClaim from "../../images/FAQ/FAQ_How_long.png";
import RAFClaim2 from "../../images/FAQ/FAQ_First_step.png";
import RAFNumber from "../../images/FAQ/FAQ RAF call centre number.png";
import RAFClaimStatus from "../../images/FAQ/FAQ RAF claim status.png";
const FAQData = [
  {
    id: "1",
    category: "RAF-claim-time",
    question: "How long does a RAF claim really take?",
    description: [
      "The honest answer: It varies A LOT, but most claimants wait 3–6 years from accident to final pay-out.",
    ],
    ul: [
      "Simple claims (clear fault, minor injuries): Often 18-24 months to settle, with payment in 6+ months thereafter.",

      "Complex claims (serious injuries, disputes, future losses): 3-5+ years is common, thanks to investigations, medical assessments, negotiations, and RAF backlogs.",

      "Even after settlement or court order, the RAF aims for payment within 180 days - but delays beyond that happen frequently.",
    ],

    p1: "",

    p2: "The RAF is working on clearing older backlogs (they've paid billions in the last quarter of 2025 on overdue claims), but reality is many victims still face long waits.",
    p3: "If you're stuck waiting for your pay-out and need funds now for medical bills, living expenses, or recovery, WeBridge can help with bridging finance. We advance part of your settlement (with your attorney's involvement) so you don't have to struggle in the meantime. ",
    summary: [
      "Summary",
      "The honest answer:  It varies A LOT, but most claimants wait 3–6 years from accident to final pay-out.",
      "Simple claims (clear fault, minor injuries): Often 18–24 months to settle, with payment in  6+ months thereafter.",
      "Complex claims (serious injuries, disputes, future losses): 3–5+ years is common, thanks to investigations, medical assessments, negotiations, and RAF backlogs.",
      "Even after settlement or court order, the RAF aims for payment within 180 days.",
    ],
    p4: "",
    p5: "",

    ImgSrc: RAFClaim,
  },
  {
    id: "2",
    category: "First-Step-after-being-injured",
    question: "What is the FIRST step after being injured in a road accident?",
    description: ["Seek immediate medical attention!"],

    p1: "Your health comes first… get to a doctor, clinic, or hospital right away, even if injuries seem minor! Some issues (like whiplash, internal bleeding, or concussion) don't show up immediately, and early medical records are crucial for proving your RAF claim later.",

    ul1Heading: "Key immediate actions:",
    ul: [
      "Get medical help -  Document everything: hospital reports, X-rays, doctor's notes, bills. This builds the foundation for past/future medical claims.",

      "Report the accident to the police (as soon as reasonably possible, ideally within 24–48 hours) - Get that official police report (AR form). It's required for your RAF claim and helps establish fault/evidence.",

      "Gather basics - Note witness details, photos of the scene/vehicles (if safe), and any other info while it's fresh.",
    ],
    p2: "From there, consult a specialized RAF attorney (no-win-no-fee) to guide the rest… lodging the claim, gathering more evidence, and avoiding pitfalls. Contact us if you need assistance in selecting an attorney, we have worked with many firms over the years and can expertly guide you. Do NOT sign any attorney’s agreements unless you have done a reference check on the attorney. Especially not while you are still in hospital! We can also provide a reference check on an attorney if you would like.",
    ul2Heading: "",

    // ul2: ["", "", ""],

    p3: "The RAF process can take years due to investigations and backlogs, so if you're facing financial strain from medical costs or lost income during the wait... WeBridge offers regulated advances on your expected payout to help bridge the gap and give you peace of mind sooner.",
    p4: "",
    p5: "",

    ImgSrc: RAFClaim2,
  },
  {
    id: "3",
    category: "RAF Call Centre number",
    question: "What is the RAF Call Centre number?",

    description: [
      "The official national Road Accident Fund Contact Centre number is",
    ],

    p1: "087 820 1 111 (Mon–Fri, 07:30–16:30)",
    ul1Heading: "This is the main line for queries like:",

    ul: [
      "Checking claim status",
      "Document submissions",
      "General questions about your RAF claim",
    ],

    p2: "Have your claim reference number, ID number, and accident details ready before calling. Lines can be busy, so patience helps.",

    ul2Heading: "Other ways to reach them:",

    ul2: [
      "Email: contactcentre@raf.co.za",
      "SMS: 44930 (for quick queries)",
      "Online: Self Service Portal at selfservice.raf.co.za (often faster for status checks)",
    ],

    p3: "If you're calling often due to long delays or backlogs, remember that RAF claims can take several years to be finalised.",

    summary: [
      "Summary",
      "The Road Accident Fund Contact Centre can be reached on 087 820 1 111 during weekdays from 07:30 to 16:30.",
      "The contact centre assists with claim status updates, document submissions, and general enquiries.",
      "You can also contact the RAF through email, SMS, or the online self-service portal.",
      "Due to delays and backlogs, RAF claims may take several years to conclude.",
    ],

    ImgSrc: RAFNumber,
  },
  {
    id: "4",
    category: "RAF Claim Status",
    question: "How do I check my RAF claim status?",

    description: [
      "Stuck wondering where your claim stands? Here are the main ways to track it (as of 2026):",
    ],

    p1: "1. Through Your Attorney (Recommended and the easiest)",

    ul: [
      "Phone your lawyer handling your claim for an update—they have direct access and can push for updates or escalate delays.",
      "RAF Self Service Portal (Online – only once your claim is lodged): Sign in (or sign up if new) using your details. You'll need your claim reference number (from your RAF1 form or attorney) and personal information such as your ID number.",
      "The portal shows real-time updates including under consideration, merits/quantum stage, documents needed, settled, and more. It is the quickest digital option and can be checked anytime.",
    ],

    p2: "2. RAF Self Service Portal (Online – only once your claim is lodged)",

    ULHeading: "Additional ways to check your claim status:",

    ulp4: [
      "Call the RAF Contact Centre on 087 820 1 111 (Mon–Fri, 07:30–16:30). Have your claim number, ID number, and accident details ready.",
      "Email: contactcentre@raf.co.za",
      "WhatsApp: 071 605 4707 for quick queries and interactive support.",
      "Visit an RAF office in person (such as Centurion HQ) with your ID and claim documentation. It is advisable to call ahead before visiting.",
    ],

    p3: "Be patient when contacting the RAF as high call volumes can result in longer waiting times. However, status updates should still be provided.",

    p4: "Pro tip: Keep records of all communications and reference numbers. RAF claims can take years due to backlogs and investigations, so regular checks help spot issues early.",

    p5: "If your claim is dragging on and you're facing financial pressure from medical bills or lost income, WeBridge can provide an advance on your expected payout, helping you access funds sooner.",

    summary: [
      "Summary",
      "Through Your Attorney (Recommended and the easiest): Phone your lawyer handling your claim for an update—they have direct access and can push for updates or escalate delays.",
      "RAF Self Service Portal (Online – only once your claim is lodged): Sign in (or sign up if new) using your details and claim reference number.",
      "The portal provides real-time updates on your claim status and is often the fastest digital option.",
      "You can also contact the RAF through their call centre, email, WhatsApp support, or by visiting an RAF office in person.",
    ],

    ImgSrc: RAFClaimStatus,
  },
  // {
  //   id: "3",
  //   category: "test",
  //   question: "test",
  //   answer: "",
  //   ImgSrc: "",
  // },
  // {
  //   id: "4",
  //   category: "test",
  //   question: "test",
  //   answer: "",
  //   ImgSrc: "",
  // },
  // {
  //   id: "5",
  //   category: "tetst2",
  //   question: "test3",
  //   answer: "",
  //   ImgSrc: "",
  // },
];

export default FAQData;
